import ProviderForm from '../../ProviderForm'
import useUpdateProviderHandler from '../../../effects/update-provider'
import { heapEvent } from '@equipmentshare/heaper'

export type EditProviderModalProps = {
  onCancel: () => void,
  onSuccess: () => void,
  onMerge: () => void,
  provider: {
    id: number,
    name: string,
  },
}

export default function EditProviderModal( { onCancel, onSuccess, onMerge, provider }: EditProviderModalProps ): JSX.Element {
	const updateProvider = useUpdateProviderHandler()

	const handleSubmit = async( updatedProvider: any ) => {
		heapEvent( 'Inventory - Edit Manufacturer Modal - Click - Submit', {} )
		return await updateProvider( updatedProvider )
	}

	const handleCancel = () => {
		heapEvent( 'Inventory - Edit Manufacturer Modal - Click - Cancel', {} )
		onCancel()
	}

	return (
		<ProviderForm
			canMerge
			onCancel={handleCancel}
			onMerge={onMerge}
			onSubmit={handleSubmit}
			onSuccess={onSuccess}
			provider={provider}
		/>
	)
}
